import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Eye = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M6 10c2.708 0 4.815-2.067 5.718-3.267.376-.466.376-1.066 0-1.533C10.815 4.067 8.708 2 6 2S1.185 4.067.282 5.267c-.376.466-.376 1.066 0 1.466C1.185 7.933 3.292 10 6 10zm0-6c1.133 0 2 .867 2 2s-.867 2-2 2-2-.867-2-2 .867-2 2-2z"
        transform="translate(-692 -1228) translate(692 1228)"
      />
    </svg>
  );
};

Eye.displayName = 'Eye';
